module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00630.5de5b425.jpg";